import { useNavigate, useSearchParams } from 'react-router-dom';
import PhoneShell from '../components/shared/PhoneShell';
import { useLang } from '../i18n';

const css = `
  .pay-result { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 70vh; padding: 24px; text-align: center; }
  .pay-anim { position: relative; width: 90px; height: 90px; margin-bottom: 24px; }
  .pay-circle { width: 90px; height: 90px; border-radius: 50%; background: rgba(255,93,108,.12); box-shadow: 0 0 0 0 rgba(255,93,108,.3); animation: pulse-err 1.8s ease infinite; display: grid; place-items: center; }
  @keyframes pulse-err { 0%,100%{box-shadow:0 0 0 0 rgba(255,93,108,.3)} 50%{box-shadow:0 0 0 18px rgba(255,93,108,0)} }
  .pay-icon { font-size: 40px; }
  .pay-title { font-size: 22px; font-weight: 800; color: #fff; margin-bottom: 8px; }
  .pay-sub { font-size: 14px; color: #9b9ab0; line-height: 1.55; max-width: 260px; }
  .pay-reasons { margin: 18px 0; padding: 14px; border-radius: 12px; background: rgba(255,93,108,.08); box-shadow: inset 0 0 0 1px rgba(255,93,108,.2); width: 100%; max-width: 300px; text-align: left; }
  .pay-reasons-title { font-size: 12px; font-weight: 700; color: #ff5d6c; margin-bottom: 8px; }
  .pay-reason { font-size: 12px; color: #9b9ab0; padding: 3px 0 3px 12px; position: relative; line-height: 1.4; }
  .pay-reason::before { content: '·'; position: absolute; left: 3px; color: #ff5d6c; }
  .pay-actions { display: flex; flex-direction: column; gap: 10px; width: 100%; max-width: 280px; margin-top: 8px; }
  .pay-btn-main { height: 48px; border-radius: 11px; background: linear-gradient(90deg, #8187f6, #76e1ff); color: #fff; font-size: 15px; font-weight: 700; border: none; font-family: inherit; cursor: pointer; }
  .pay-btn-sec { height: 44px; border-radius: 11px; background: #16142e; box-shadow: inset 0 0 0 1px rgba(255,255,255,.1); color: #cfcee0; font-size: 14px; font-weight: 600; border: none; font-family: inherit; cursor: pointer; }
  .pay-order { font-size: 11px; color: #5a5972; margin-top: 16px; }
`;

export default function PaymentFailed() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderId  = params.get('MERCHANT_ORDER_ID') || params.get('us_id') || null;

  return (
    <PhoneShell activeTab="">
      <style>{css}</style>
      <div className="pay-result">
        <div className="pay-anim">
          <div className="pay-circle">
            <span className="pay-icon">❌</span>
          </div>
        </div>

        <h1 className="pay-title">{t('payment.failedTitle')}</h1>
        <p className="pay-sub">{t('payment.failedSub')}</p>

        <div className="pay-reasons">
          <div className="pay-reasons-title">{t('payment.possibleCauses')}</div>
          {['cause1', 'cause2', 'cause3', 'cause4'].map((k) => (
            <div className="pay-reason" key={k}>{t('payment.' + k)}</div>
          ))}
        </div>

        <div className="pay-actions">
          <button className="pay-btn-main" onClick={() => navigate('/deposit')}>{t('payment.retryDeposit')}</button>
          <button className="pay-btn-sec"  onClick={() => navigate('/')}>{t('payment.backHome')}</button>
        </div>

        {orderId && <p className="pay-order">{t('payment.reference', { id: orderId })}</p>}
      </div>
    </PhoneShell>
  );
}
